"use client"
import { Windmill } from "@windmill/react-ui"
export default function Providers({ children }: { children: React.ReactNode }) {
  return <Windmill usePreferences>{children}</Windmill>
}
